import { SET_MENU_SUBTEXT } from 'common/constants/action-types';
import { AppDispatch } from 'index';

export const setMenuSubText = (subText: string | string[]) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: SET_MENU_SUBTEXT,
      payload: Array.from(subText)
        .filter(Boolean)
        .map((text) => text.toString())
    });
  };
};

export const clearMenuSubText = () => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: SET_MENU_SUBTEXT,
      payload: undefined
    });
  };
};
